export default "__VITE_ASSET__Ct34Wifz__"